import {
  QUICK_ADD
} from 'permissions/actions'

export const DEAL_STAGE = '@@permissions/policy/dealStage'

export default {
  [QUICK_ADD]: (user, options) => !!user.is_account_admin && !user.read_only
}
